export const FONTS = [
  { id: "default", label: "Default" },
  { id: "minecraft", label: "Minecraft" },
  { id: "fortnite", label: "Fortnite" },
  { id: "pixel", label: "Pixel Arcade" },
  { id: "orbitron", label: "Orbitron" },
  { id: "bungee", label: "Bungee" },
  { id: "marker", label: "Graffiti" },
  { id: "playfair", label: "Elegant" },
  { id: "mono", label: "Mono" },
  { id: "caveat", label: "Handwritten" },
];

const FONT_FAMILIES = {
  default: "",
  minecraft: "'Minecraft', 'VT323', monospace",
  fortnite: "'Fortnite', 'Burbank Big Condensed', 'Bungee', sans-serif",
  pixel: "'Press Start 2P', monospace",
  orbitron: "'Orbitron', sans-serif",
  bungee: "'Bungee', cursive",
  marker: "'Permanent Marker', cursive",
  playfair: "'Playfair Display', serif",
  mono: "'JetBrains Mono', monospace",
  caveat: "'Caveat', cursive",
};

export const fontFamily = (id) => FONT_FAMILIES[id] || "";

export const AVATAR_EFFECTS = [
  { id: "none", label: "None" },
  { id: "glow", label: "Glow" },
  { id: "pulse", label: "Pulse" },
  { id: "rainbow-ring", label: "Rainbow Ring" },
  { id: "spin", label: "Spin Ring" },
  { id: "particles", label: "Particles" },
];

export const LAYOUTS = [
  { id: "classic", label: "Classic", desc: "Centered glass card" },
  { id: "minimal", label: "Minimal", desc: "No card, text on background" },
  { id: "left", label: "Left Aligned", desc: "Avatar & text left" },
  { id: "hero", label: "Hero Banner", desc: "Banner with overlapping avatar" },
];

// Each theme applies a bundle of profile settings in one tap.
export const THEMES = [
  { id: "midnight", label: "Midnight", bg: "#08080A", accent: "#8B5CF6", name_effect: "purple", avatar_effect: "glow", font: "default", layout: "classic", swatch: ["#08080A", "#8B5CF6", "#d946ef"] },
  { id: "cyberpunk", label: "Cyberpunk", bg: "#0a0012", accent: "#22d3ee", name_effect: "glitch", avatar_effect: "spin", font: "orbitron", layout: "hero", swatch: ["#0a0012", "#22d3ee", "#ec4899"] },
  { id: "minecraft", label: "Minecraft", bg: "#0d1f0d", accent: "#52a535", name_effect: "bounce", avatar_effect: "pulse", font: "minecraft", layout: "classic", swatch: ["#0d1f0d", "#52a535", "#8bc34a"] },
  { id: "fortnite", label: "Fortnite", bg: "#0b1026", accent: "#3b82f6", name_effect: "glow", avatar_effect: "rainbow-ring", font: "fortnite", layout: "hero", swatch: ["#0b1026", "#3b82f6", "#a855f7"] },
  { id: "sunset", label: "Sunset", bg: "#1a0a08", accent: "#f97316", name_effect: "fire", avatar_effect: "glow", font: "bungee", layout: "classic", swatch: ["#1a0a08", "#f97316", "#ff0000"] },
  { id: "ocean", label: "Ocean", bg: "#04141f", accent: "#0ea5e9", name_effect: "ocean", avatar_effect: "pulse", font: "default", layout: "minimal", swatch: ["#04141f", "#0ea5e9", "#22d3ee"] },
  { id: "goldluxe", label: "Gold Luxe", bg: "#0f0d06", accent: "#f5d67b", name_effect: "gold", avatar_effect: "glow", font: "playfair", layout: "left", swatch: ["#0f0d06", "#f5d67b", "#fff6d6"] },
  { id: "vaporwave", label: "Vaporwave", bg: "#160a1f", accent: "#ec4899", name_effect: "rainbow", avatar_effect: "rainbow-ring", font: "marker", layout: "classic", swatch: ["#160a1f", "#ec4899", "#22d3ee"] },
  { id: "matrix", label: "Matrix", bg: "#020a02", accent: "#22c55e", name_effect: "glow", avatar_effect: "particles", font: "mono", layout: "minimal", swatch: ["#020a02", "#22c55e", "#86efac"] },
  { id: "bloodmoon", label: "Blood Moon", bg: "#120305", accent: "#ef4444", name_effect: "glitch", avatar_effect: "glow", font: "bungee", layout: "hero", swatch: ["#120305", "#ef4444", "#f87171"] },
  { id: "bubblegum", label: "Bubblegum", bg: "#1b0a16", accent: "#f472b6", name_effect: "rainbow", avatar_effect: "pulse", font: "bungee", layout: "classic", swatch: ["#1b0a16", "#f472b6", "#f9a8d4"] },
  { id: "arctic", label: "Arctic", bg: "#070e14", accent: "#7dd3fc", name_effect: "fuzzy", avatar_effect: "spin", font: "playfair", layout: "left", swatch: ["#070e14", "#7dd3fc", "#e0f2fe"] },
  { id: "retro", label: "Retro Arcade", bg: "#0a0320", accent: "#fbbf24", name_effect: "shuffle", avatar_effect: "rainbow-ring", font: "pixel", layout: "classic", swatch: ["#0a0320", "#fbbf24", "#f472b6"] },
  { id: "noir", label: "Noir", bg: "#0b0b0d", accent: "#d4d4d8", name_effect: "typewriter", avatar_effect: "none", font: "mono", layout: "minimal", swatch: ["#0b0b0d", "#d4d4d8", "#52525b"] },
];
